import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  linkText?: string;
  linkTo?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  linkText,
  linkTo,
  align = "left",
}: SectionHeadingProps) {
  return (
    <div
      className={`mb-6 flex flex-col gap-3 md:mb-8 md:flex-row md:items-end md:justify-between ${
        align === "center" ? "md:flex-col md:items-center" : ""
      }`}
    >
      <div className={align === "center" ? "text-center" : ""}>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-accent-700">
            <i className="ri-bookmark-3-line"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {linkText && linkTo && (
        <Link
          to={linkTo}
          className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          {linkText}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}